import { Pipe, PipeTransform } from '@angular/core';
import { OldPortfolio, WebUserDataConstants } from '@ddt-web/domain';

import { JsonToPortfolioPipe } from './json-to-portfolio.pipe';

@Pipe({
	name: 'jsonArrayToPortfolioArray'
})
export class JsonArrayToPortfolioArrayPipe implements PipeTransform {
	private jsontoPortfolioPipe: JsonToPortfolioPipe = new JsonToPortfolioPipe();

	public transform(portfolioJsonArray: any): Array<OldPortfolio> {
		const portfolios: Array<OldPortfolio> = [];

		if (!portfolioJsonArray) {
			console.error('Error converting portfolios - returning empty array!');
			return portfolios;
		}

		for (const jsonObject of portfolioJsonArray) {
			if (this.isNotPortfolio(jsonObject)) {
				continue;
			}

			const portfolio: OldPortfolio = this.jsontoPortfolioPipe.transform(jsonObject);

			if (portfolio === null) {
				continue;
			}

			portfolios.push(portfolio);
		}

		return portfolios;
	}

	public transformWithoutPosition(portfolioJsonArray: any): Array<OldPortfolio> {
		const portfolios: Array<OldPortfolio> = [];

		if (!portfolioJsonArray) {
			console.error('Error converting portfolios - returning empty array!');
			return portfolios;
		}

		for (const jsonObject of portfolioJsonArray) {
			if (this.isNotPortfolio(jsonObject)) {
				continue;
			}

			const portfolio: OldPortfolio = this.jsontoPortfolioPipe.transformWithoutPosition(jsonObject);

			if (portfolio === null) {
				continue;
			}

			portfolios.push(portfolio);
		}

		return portfolios;
	}

	private isNotPortfolio(result: any): boolean {
		const isPortfolio = result?.type === WebUserDataConstants.TYPE.PORTFOLIO;
		const isTaxList = result?.type === WebUserDataConstants.TYPE.PORTFOLIO_LIKE && result?.subType === WebUserDataConstants.SUBTYPE.TAX_REPORT;
		return !(isPortfolio || isTaxList);
	}
}
